import React from 'react'

import { ContentStateProperty, FieldProps } from '../../../../../../../@types/types'
import { ConstructionScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'
import { MandatoryHintWrapper } from '../../../../../../common/display/mandatoryHint/MandatoryHintWrapper'

export interface ThermalCharacteristicProps extends Omit<FieldProps<ConstructionScreenValidationResult>, 'onChange'> {
  validators: ConstructionScreenValidationResult
  isInternationalAddress: boolean
  thermalCharacteristicInputLabel: JSX.Element
  onEnergyCertificateChange: (field: ContentStateProperty, value: string | boolean | undefined) => void
}

const ThermalCharacteristicField: React.FC<ThermalCharacteristicProps> = ({
  insertionData,
  validators,
  isInternationalAddress,
  thermalCharacteristicInputLabel,
  onEnergyCertificateChange,
  wrapperClassName,
}) => (
  <div className={wrapperClassName}>
    <TextInput
      id='thermal-characteristic'
      propertyName='thermalCharacteristic'
      value={insertionData.thermalCharacteristic}
      label={thermalCharacteristicInputLabel}
      errors={validators.thermalCharacteristic ?? []}
      affixRight='unit'
      unitRight='kilowattHour'
      placeholder=''
      maxLength={8}
      doOnFieldChange={(field, value) => onEnergyCertificateChange(field, value)}
    />
    {(insertionData.consumptionContainsWarmWater || isInternationalAddress) && (
      <MandatoryHintWrapper showMandatoryHint={true} />
    )}
  </div>
)

export default ThermalCharacteristicField
